import React from "react";
import PropTypes from "prop-types";
import { BarChart, Bar, ResponsiveContainer, Tooltip } from "recharts";

//--- include its css ---
import "./barChart.scss";

function BarChartBox(props) {
  return (
    <div className="tickets">
      <h1>{props.title}</h1>
      <div className="chart">
        <ResponsiveContainer width="99%" height={150}>
          <BarChart data={props.chartData}>
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              labelStyle={{ display: "none" }}
              cursor={{ fill: "none" }}
            />
            <Bar dataKey={props.dataKey} fill={props.color} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
BarChartBox.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  dataKey: PropTypes.string,
  chartData: PropTypes.arrayOf(PropTypes.object),
};
export default BarChartBox;
